import React from 'react';
import { Typography, Card, Row, Col } from 'antd';
import { useTheme } from '../../theme/ThemeProvider';
import './styles.css';

const { Title, Paragraph, Text } = Typography;

const About: React.FC = () => {
  const { theme } = useTheme();

  return (
    <div className="about-container">
      <div className="about-header">
        <Title level={1} style={{ color: theme.text.primary, textAlign: 'center', marginBottom: '8px' }}>
          درباره ما
        </Title>
        <Text style={{ color: theme.text.secondary, fontSize: '18px', textAlign: 'center' }}>
          شرکت حمل و نقل هوشمند شهسا
        </Text>
      </div>

      <Row gutter={[24, 24]} className="about-content">
        <Col xs={24} lg={16}>
          <Card 
            className="about-card"
            style={{ 
              backgroundColor: theme.surface,
              borderColor: theme.border,
              color: theme.text.primary
            }}
          >
            <Title level={3} style={{ color: theme.text.primary, marginBottom: '20px' }}>
              معرفی شرکت
            </Title>
            
            <Paragraph style={{ color: theme.text.secondary, fontSize: '16px', lineHeight: '1.8', textAlign: 'justify' }}>
              شرکت شهسا با بیش از ۱۰ سال تجربه در زمینه حمل و نقل هوشمند، ارائه‌دهنده خدمات نوین سفر در سراسر کشور است. 
              ما با استفاده از فناوری‌های پیشرفته و تیم متخصص، تجربه سفر راحت، امن و مقرون به صرفه را برای مشتریان فراهم می‌کنیم.
            </Paragraph>

            <Paragraph style={{ color: theme.text.secondary, fontSize: '16px', lineHeight: '1.8', textAlign: 'justify' }}>
              هدف ما ارائه خدمات با کیفیت بالا و استفاده از تکنولوژی‌های روز دنیا برای بهبود تجربه سفر کاربران است. 
              با پشتیبانی ۲۴ ساعته و تیم متخصص، همیشه در کنار شما هستیم.
            </Paragraph>
          </Card>


        </Col>

        <Col xs={24} lg={8}>
          <Card 
            className="about-card"
            style={{ 
              backgroundColor: theme.surface,
              borderColor: theme.border,
              color: theme.text.primary
            }}
          >
            <Title level={3} style={{ color: theme.text.primary, marginBottom: '20px' }}>
              اطلاعات تماس
            </Title>
            
            <div className="contact-info">
              <div className="contact-item">
                <Text strong style={{ color: theme.text.primary }}>آدرس:</Text>
                <Text style={{ color: theme.text.secondary, marginRight: '8px' }}>
                  تهران، خیابان ولیعصر
                </Text>
              </div>
              
              <div className="contact-item">
                <Text strong style={{ color: theme.text.primary }}>تلفن:</Text>
                <Text style={{ color: theme.text.secondary, marginRight: '8px' }}>
                  ۰۲۱-۱۲۳۴۵۶۷۸
                </Text>
              </div>
              
              <div className="contact-item">
                <Text strong style={{ color: theme.text.primary }}>ایمیل:</Text>
                <Text style={{ color: theme.text.secondary, marginRight: '8px' }}>
                  info@shahsa.ir
                </Text>
              </div>
              
              <div className="contact-item">
                <Text strong style={{ color: theme.text.primary }}>ساعات کاری:</Text>
                <Text style={{ color: theme.text.secondary, marginRight: '8px' }}>
                  ۲۴ ساعته
                </Text>
              </div>
            </div>
          </Card>


                 </Col>
       </Row>
       
       {/* App Version at bottom center */}
       <div className="app-version-bottom">
         <Text style={{ 
           color: theme.text.secondary, 
           fontSize: '14px',
           opacity: 0.7,
           textAlign: 'center'
         }}>
           نسخه ۱.۰.۰
         </Text>
       </div>
     </div>
   );
 };

export default About;
